import React from 'react';
type ProgressBarProps = {
  rangeLabel: string;
  answered: number;
  total: number;
};
export function ProgressBar({
  rangeLabel,
  answered,
  total
}: ProgressBarProps) {
  const percent = Math.round(answered / total * 100);
  return <div className="pt-6" data-id="element-20" data-mp="1d48dbq386rfv">
      <div className="mb-2 flex items-baseline justify-between text-xs text-ink-muted" data-id="element-21" data-mp="1d0atf28tpvux">
        <span data-id="element-22" data-mp="185nd3qnz47rf">{rangeLabel}</span>
        <span data-id="element-23" data-mp="1m33m99xnmfmv">
          {answered} of {total} answered
        </span>
      </div>
      <div className="h-[3px] w-full overflow-hidden rounded-full bg-border" role="progressbar" aria-valuenow={answered} aria-valuemin={0} aria-valuemax={total} aria-label="Assessment progress" data-id="element-24" data-mp="1i1qe2t73a0cs">
        <div className="h-full rounded-full bg-harbor transition-[width] duration-300 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-25" data-mp="1qvd7icntqrit" />
      </div>
    </div>;
}